export class ProjectObject {
    name: string | undefined;
    projectStatus: string | undefined;
    estCompletionDate: Date | undefined;
    projectNumber: string | undefined;

    constructor(
        name: string | undefined,
        projectStatus: string | undefined,
        estCompletionDate: Date | undefined,
        projectNumber: string | undefined
    ) {
        this.name = name;
        this.projectStatus = projectStatus;
        this.estCompletionDate = estCompletionDate;
        this.projectNumber = projectNumber;
    }
}

export class ProjectsState {
    projects: ProjectObject[];
    loading: boolean;
}


// WEBPACK FOOTER //
// ./src/data/projects/projectsModels.ts